import { Injectable } from '@angular/core';
import { type EportraitIframeMessageEventModel } from '../models/eportrait-iframe-message-event.model';
import { type IframeMessageEventModel } from '../models/iframe-message-event.model';

@Injectable({
    providedIn: 'root',
})
export class IframeService {
    private idCounter = 0;

    public nextId(): number {
        this.idCounter = this.idCounter + 1;

        return this.idCounter;
    }

    /**
     * Send a MessageEvent safely between cross-origins
     * @param contentWindow The reference to the window that will receive the message.
     * @param event The event object to send.
     * @param targetOrigin The target origin of the window that sent the message at the time postMessage was called.
     */
    public postMessage(contentWindow: Window, event: EportraitIframeMessageEventModel | IframeMessageEventModel, targetOrigin: string): void {
        contentWindow.postMessage(event, targetOrigin);
    }
}
